


export abstract class EventsBlueprint {
    abstract prompt: string
    abstract start(): void
}
